module.exports = __webpack_public_path__ + "img/tuozhan01.e11084bd.png";